import Select, { SelectProps } from "@/shared/form/select";
import { CompanyDocumentReadConfirmationType } from "gql/graphql";
import { useDocumentsTranslations } from "@/modules/documents/shared/utils/use-documents-translations";

export function ReadConfirmationTypeSelect(props: SelectProps) {
  const t = useDocumentsTranslations();

  return (
    <Select
      options={Object.values(CompanyDocumentReadConfirmationType).map(
        (type) => ({
          value: type,
          label: t(type),
        }),
      )}
      {...props}
    />
  );
}
